import React, { useState } from 'react';
import HeaderBurgerMenuToggle from './HeaderBurgerMenuToggle';
import HeaderBurgerMenu from './HeaderBurgerMenu';
import User from '@/types/user';
import NavigationItem from '@/types/navigation-item';

interface HeaderBurgerMenuContainerProps {
  menuItems: NavigationItem[];
  user: User;
}

const HeaderBurgerMenuContainer: React.FC<HeaderBurgerMenuContainerProps> = ({ menuItems, user }) => {
  const [open, setOpen] = useState(false);
  const handleToggle = () => setOpen(prev => !prev);

  return (
    <>
      <HeaderBurgerMenuToggle open={open} handleToggle={handleToggle} />
      <HeaderBurgerMenu menuItems={menuItems} user={user} open={open} setOpen={setOpen} />
    </>
  );
};

export default HeaderBurgerMenuContainer;
